import { h, render } from 'preact';
import * as BaseComp from 'components/bolt/text/text.js';
import s from 'components/bolt/text/text.sss';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import Store from 'store/store';
import HTML from 'components/core/html/html';
import { navigateInternally } from 'utils/bolt/index';
import { getDynamicData } from 'utils/bolt/dynamicData';

import Facebook from 'components/bolt/icons/facebook';
import Bluesky from 'components/bolt/icons/bluesky';
import Twitter from 'components/bolt/icons/twitter';
import Twitch from 'components/bolt/icons/twitch';
import Instagram from 'components/bolt/icons/instagram';
import Youtube from 'components/bolt/icons/youtube';
import Snapchat from 'components/bolt/icons/snapchat';
import Tiktok from 'components/bolt/icons/tiktok';
import Spotify from 'components/bolt/icons/spotify';
import Pinterest from 'components/bolt/icons/pinterest';
import Giphy from 'components/bolt/icons/giphy';
import Tumblr from 'components/bolt/icons/tumblr';
import Vimeo from 'components/bolt/icons/vimeo';
import Mail from 'components/bolt/icons/mail';
import Threads from 'components/bolt/icons/threads';

const icons = {
	facebook: Facebook,
	bluesky: Bluesky,
	twitter: Twitter,
	twitch: Twitch,
	instagram: Instagram,
	youtube: Youtube,
	snapchat: Snapchat,
	tiktok: Tiktok,
	spotify: Spotify,
	pinterest: Pinterest,
	giphy: Giphy,
	tumblr: Tumblr,
	vimeo: Vimeo,
	email: Mail,
	threads: Threads,
};

export default class Text extends BaseComp.default {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,

			hasScrolledPast: false,
		};
		this.downloadPDF = this.downloadPDF.bind(this);
		this.onClickApply = this.onClickApply.bind(this);
		this.onClickSocial = this.onClickSocial.bind(this);
		this.handleButton = this.handleButton.bind(this);
	}

	async componentDidMount() {
		super.componentDidMount?.();

		if (this.props.appData?.options?.cmsManaged) {
			await this.loadCustomData();
		}

		observeScroll(this.base, { once: true });

		this.pageData = this.props.appData?.pages?.[this.props.id]?.data || {};

		if (this.props.id === 'homeMission') {
			this.container = document.querySelector(`.${s.container}`);

			this.contentWrapper = document.querySelector(`.${s.content}`);
			this.homeMissionContainer = document.querySelector('.statement');
			this.homeMissionSub = document.querySelector('.statementSub');

			this.sentence = this.homeMissionContainer?.innerHTML.trim();
			this.homeMissionContainer.innerHTML = '';
			const words = this.sentence.trim().split(/\s+/);
			words.forEach(word => {
				const span = document.createElement('span');
				span.className = 'word';
				span.textContent = word;
				span.style.transitionDelay = `${+this.pageData?.startDelay}s`;
				this.homeMissionContainer.appendChild(span);
			});

			this.wordElements = document.querySelectorAll('.word');
			this.wordElements.forEach((word, index) => {
				word.classList.remove(s.visible);
				// word.style.transitionDelay = `${+this.pageData?.startDelay}s`;
				word.style.animationDuration = `${+this.pageData?.startDelay + +this.pageData?.wordDelay}s`;
				word.style.animationDelay = `${(index * 0.15)}s`;
			});
		}
	}

	// Junky solution for markdown rendering
	renderMarkdown(text) {
		if (!text) return '';

		return text
			// Bold: **text**
			.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
			// Italic: *text*
			.replace(/\*(.*?)\*/g, '<em>$1</em>')
			// Underline: __text__
			.replace(/__(.*?)__/g, '<u>$1</u>')
			// Strikethrough: ~~text~~
			.replace(/~~(.*?)~~/g, '<s>$1</s>')
			// Links: [text](url)
			.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank">$1</a>');
	}

	async loadCustomData() {
		if (this.props?.id === 'filmmakersStrategiesAbout') {
			const dynamicData = await getDynamicData('filmmakers-strategies');
			this.dynamicEligibilityData = dynamicData.filmmakersStrategiesEligibility;
			const root = this.base;
			const titleEl = root.querySelector('.title');
			if (titleEl) {
				titleEl.textContent = dynamicData.filmmakersStrategiesAbout.title;
			}
			const bodyEl = root.querySelector('.body');
			if (bodyEl && bodyEl.parentNode) {
				const bodyParent = bodyEl.parentNode;
				bodyEl.innerHTML = '';
				render(<HTML class={s.body} content={dynamicData.filmmakersStrategiesAbout.description} markdown />, bodyParent);
			}
		}
		if (this.props?.id === 'filmmakersStrategiesEligibility') {
			const dynamicData = await getDynamicData('filmmakers-strategies');
			this.dynamicEligibilityData = dynamicData.filmmakersStrategiesEligibility;

			const root = this.base;
			root.querySelector('.title').innerHTML = this.dynamicEligibilityData.title;
			root.querySelector('.subtitle').innerHTML = this.dynamicEligibilityData.subtitle;
			root.querySelector('.body').innerHTML = this.dynamicEligibilityData.description;
		}

		if (this.props?.id === 'filmmakersStrategiesApply') {
			const dynamicData = await getDynamicData('filmmakers-strategies');
			this.dynamicApplyData = dynamicData.filmmakersStrategiesApply;
		}


		if (this.props?.id === 'homeMission') {
			const dynamicData = await getDynamicData('landing');
			const { heading, subheading } = dynamicData.missionStatement;

			const headingEl = document.querySelector('.statement');
			if (headingEl) headingEl.innerHTML = heading;

			const subheadingEl = document.querySelector('.statementSub');
			if (subheadingEl) subheadingEl.innerHTML = this.renderMarkdown(subheading);
		}
		if (this.props?.id === 'homeTalentDevelopment') {
			const dynamicData = await getDynamicData('landing');
			if (dynamicData?.utdi) {
				const { image, annotation, button } = dynamicData.utdi;

				const bgEl = document.querySelector('.background');
				if (bgEl) bgEl.src = image;

				const logoEl = document.querySelector('.utdLogo');
				if (logoEl) {
					if (dynamicData.utdi.enabled) {
						logoEl.src = dynamicData.utdi.logo;
						logoEl.style.display = '';
					} else {
						logoEl.style.display = 'none';
					}
				}
				const annotationEl = document.querySelector('.utdAnnotation');
				if (annotationEl) {
					annotationEl.innerHTML = this.renderMarkdown(annotation);
				}

				const buttonEl = document.querySelector('.utdButton');
				if (buttonEl) {
					buttonEl.innerText = button.label;
					buttonEl.setAttribute('data-text', button.label);
					buttonEl.removeAttribute('href');
					buttonEl.dataset.link = button.link;

					buttonEl.onclick = (e) => {
						const dest = e.currentTarget.dataset.link;

						if (dest.startsWith('https')) {
							window.open(dest, '_blank');
						} else {
							navigateInternally(dest);
						}
					};
				}
			}
		}

		if (this.props?.id === 'homeNbcUniversalCareers') {
			const dynamicData = await getDynamicData('landing');
			const titleEl = document.querySelector('.title');
			if (titleEl) {
				titleEl.textContent = dynamicData.careers.title;
			}
			const buttonEl = document.querySelector('.button');
			if (buttonEl && dynamicData.careers.button) {
				buttonEl.textContent = dynamicData.careers.button.label;
				buttonEl.setAttribute('data-text', dynamicData.careers.button.label);
				buttonEl.onclick = () => {
					window.open(dynamicData.careers.button.link, '_blank');
				};
			}
		}

		if (this.props?.id === 'utdAbout') {
			const dynamicData = await getDynamicData('utd');

			const { title, description } = dynamicData.talentDevelopmentAbout;

			const headingEl = document.querySelector('.title');
			if (headingEl) headingEl.innerHTML = title;

			const subheadingEl = document.querySelector('.description');
			if (subheadingEl) {
				subheadingEl.innerHTML = '';
				render(<HTML class={s.description} content={description} markdown />, subheadingEl);
			}
		}

		if (this.props?.id === 'utdSocial') {
			const dynamicData = await getDynamicData('utd');
			const utdSocialData = dynamicData?.utdSocial || {};
			this.setState({ utdSocialData: utdSocialData || this.props.data });
		}

		if (this.props?.id === 'belowTheLineAbout') {
			const dynamicData = await getDynamicData('below-the-line');
			const { title, description } = dynamicData.belowTheLineAbout;
			const headingEl = document.querySelector('.title');
			if (headingEl) {
				headingEl.innerHTML = '';
				render(<HTML tag="h1" class={s.title} content={title} markdown />, headingEl);
			}
			const subheadingEl = document.querySelector('.description');
			if (subheadingEl) {
				subheadingEl.innerHTML = '';
				render(<HTML class={s.description} content={description} markdown />, subheadingEl);
			}
		}

		if (this.props?.id === 'composersInitiativeAbout') {
			const dynamicData = await getDynamicData('composers-initiative');
			const { title, description } = dynamicData.composersInitiativeAbout;
			const headingEl = document.querySelector('.title');
			if (headingEl) {
				headingEl.innerHTML = '';
				render(<HTML tag="h1" class={s.title} content={title} markdown />, headingEl);
			}
			const subheadingEl = document.querySelector('.description');
			if (subheadingEl) {
				subheadingEl.innerHTML = '';
				render(<HTML class={s.description} content={description} markdown />, subheadingEl);
			}
		}
		if (this.props?.id === 'composersInitiativeApply') {
			const dynamicData = await getDynamicData('composers-initiative');
			this.dynamicApplyData = dynamicData.composersInitiativeApply;
		}
		if (this.props?.id === 'composersInitiativeEligibility') {
			const dynamicData = await getDynamicData('composers-initiative');
			this.dynamicEligibilityData = dynamicData.composersInitiativeEligibility;

			const root = this.base;
			root.querySelector('.title').innerHTML = this.dynamicEligibilityData.title;
			root.querySelector('.subtitle').innerHTML = this.dynamicEligibilityData.subtitle;
			root.querySelector('.body').innerHTML = this.dynamicEligibilityData.description;
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();

		unobserveScroll(this.base);
	}

	getPageData() {
		return this.props.appData?.pages?.[this.props.id]?.data || {};
	}

	getButtons() {
		return 	Object.values(this.getPageData().buttons) || [];
	}


	handleButton(button) {
		const { pdfSrcOrLink, label } = button;
		const isExternalLink = pdfSrcOrLink => /^((https?:)|mailto:)/.test(pdfSrcOrLink);
		
		if (pdfSrcOrLink.includes('.pdf')) {
			this.downloadPDF(button);
		} else if (isExternalLink) {
			window.open(pdfSrcOrLink);

			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'pdf-download-click',
				label: label + '_' + pdfSrcOrLink
			});
		}
	}

	async downloadPDF( button ) {
		const { pdfSrcOrLink, label } = button;
		let fileName = pdfSrcOrLink?.split('/')?.pop();

		if (pdfSrcOrLink) {
			const result = await fetch(pdfSrcOrLink);
			const blob = await result.blob();
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.dataset.downloadurl = ['application/octet-stream', link.download, link.href].join(':');
			link.click();
		}
		this.setState({ downloadingPDF: false });
		
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'pdf-download-click',
			label: label + '_' + fileName
		});
	}

	onClickApply(finalPath) {
		const { applyBtnCopy } = this.props.data;
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'CTA-click',
			label: applyBtnCopy + '_' + finalPath
		});
		window.open(finalPath);
	}

	triggerWordSequenceAnimation() {
		this.wordElements.forEach((word, index) => {
			setTimeout(() => {
				word.classList.add(s.visible);
			}, +this.pageData?.startDelay + (index * +this.pageData?.wordDelay));
		});
		setTimeout(() => {
			this.homeMissionSub.classList.add(s.visible);
		}, +this.pageData?.startDelay + (this.wordElements.length * +this.pageData?.wordDelay));
	}

	triggerGradientTextAnimation() {
		this.wordElements.forEach(word => {
			word.classList.remove(s.visible);
			word.classList.add(s.animateWordGradientBackground);
		});
		this.homeMissionContainer.classList.add(s.animateGradientBackground);
	}

	renderText() {
		if (this.props.id === 'utdSocial') {
			return this.renderAboutSocial(this.props.data);
		}
		if (this.props.id === 'homeMission') {
			if (this.container && !this.state.hasScrolledPast) {
				const attributes = Array.from(this.container.attributes).map(attr => attr.name);
				if (attributes?.includes('scrolled-past')) {
					this.setState({ hasScrolledPast: true });
					this.triggerWordSequenceAnimation();
					setTimeout(() => {
						this.triggerGradientTextAnimation();
					}, 4000);
				}
			}
		}
		if (this.props.id.includes('Apply')) {
			const merged = {
				...this.props.data,
				...this.dynamicApplyData
			};
			return this.renderApply(merged);
		}

		return super.renderText();
	}

	onClickSocial(icon, path) {
		
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'CTA-click',
			label: icon + '_' + path
		});
	}

	onClick(e) {
		let destination = '';
		let buttonLabel = '';
		const match = this.text.match(/window\.open\(['"]([^'"]+)['"]/);
		if (match) {
			destination = match[1];
			
		} 
		const labelMatch = this.text.match(/<(?:a|button)[^>]*>(.*?)<\/(?:a|button)>/i);
		if (labelMatch) {
			buttonLabel = labelMatch[1];
		} 
	
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			destination = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (destination.includes('/?')) {
				let [pageId, qs] = destination.split('/?');
				destination = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(destination, navOptions);
		}

		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'CTA-click',
			label: buttonLabel + '_' + destination
		});
	}

	renderApply() {
		const data = this.dynamicApplyData || this.props.data;
		if (!data) return null;

		const { title, description, applyButton } = data;
		const finalLabel = applyButton?.applyBtnCopy || data.applyBtnCopy;
		const finalPath = applyButton?.applyBtnPath || data.applyBtnPath;

		return (
			<div class={s.content}>
				{title && <h1>{title}</h1>}

				{finalLabel && (
					<button
						class={s.applyBtn}
						data-text={finalLabel}
						onClick={() => this.onClickApply(finalPath)}
					>
						{finalLabel}
					</button>
				)}

				{description && <p>{description}</p>}

				{this.renderPDFButtons(data.buttons || this.getButtons())}
			</div>
		);
	}
	
	renderPDFButtons(buttons = []) {
		if (!buttons) return null;

		if (!Array.isArray(buttons)) {
			buttons = Object.values(buttons);
		}

		if (!buttons.length) return null;

		return buttons.map(button => {
			const url = button.pdfSrcOrLink || (button.link || button.file);
			const { label } = button;
			if (!label || !url) return null;

			return (
				<button
					class={s.downloadBtn}
					data-text={label}
					onClick={() => this.handleButton({ pdfSrcOrLink: url, label })}
				>
					{label}
				</button>
			);
		});
	}

	renderAboutSocial() {
		const data = this.state.utdSocialData || this.props.data || {};
		const title = data.title || 'Join Us';

		const tiles = (data.socialLinks && data.socialLinks.length)
			? data.socialLinks.map(link => ({
				icon: link.alt?.split('-')[0],
				label: link.socialHandle,
				path: link.link,
				file: link.file
			}))
			: sortObjectByOrder([{ ...data.tile1 }, { ...data.tile2 }]);

		return (
			<div class={s.joinUsContainer}>
				<h1 class={s.title}>{title}</h1>
				<div class={s.socialGrid}>
					{tiles.map(({ icon, label, path, file }) => {
						const Icon = icons[icon];
						return (
							<a
								href={path}
								onClick={() => this.onClickSocial(icon, path)}
								class={s.socialCard}
								key={icon}
								target="_blank"
								rel="noopener noreferrer"
							>
								<div class={s.socialContent}>
									{Icon
										? <Icon class={s.socialIcon || s.icon} />
										: <img src={file} class={s.socialIcon || s.icon} alt={icon} />
									}
									<p class={s.socialLink}>{label}</p>
								</div>
							</a>
						);
					})}
				</div>
			</div>
		);
	}

	render({ store, id }) {
		if ((id === 'filmmakersStrategiesEligibility' || id === 'composersInitiativeEligibility') && this.dynamicEligibilityData?.enabled === false) {
			return null;
		}
		if ((id === 'filmmakersStrategiesApply' || id === 'composersInitiativeApply') && this.dynamicApplyData?.enabled === false) {
			return null;
		}


		const currentPage = accessNested(store, `appData.pages.${id}`, {});
		const section = accessNested(store, `appData.pages.${id}.section`);
		const headerHeight = accessNested(store, `client.headerHeight`, '');
		const isDesktopWidth = accessNested(store, 'client.isDesktopWidth');
		const hasGallery = accessNested(store, `appData.pages.${id}.data.gallery`, '');
		const needsPushDown = !isDesktopWidth && !section;
		const width = this.getPageWidth(currentPage, section);
		const text = this.renderText();
		const countdownClock = accessNested(store, `appData.pages.${id}.data.countdownClock`, null);
		const countdownPos = countdownClock?.position || 'standard';

		return (
			<div class={joinClasses(s.container, id, !section && s.dedicatedPage, countdownClock && s.hasCountdownClock)} data-section={id}>
				<div style={{ width, marginTop: needsPushDown ? `${headerHeight}px` : '0px' }} class={joinClasses(s.wrapper, currentPage.data.bg && s.noBg)} key="wrapper">
					{(countdownClock && countdownPos === 'top') && this.renderCountdown(countdownClock, countdownPos)}
					{this.renderBgContent()}
					{text}
					{this.renderOverlayedContent()}
				</div>
				{hasGallery && this.renderGallery()}
				{(countdownClock && countdownPos === 'standard') && this.renderCountdown(countdownClock, countdownPos)}
			</div>
		);
	}
}
